import {clsx} from 'clsx'
import {type ComponentPropsWithoutRef, forwardRef} from 'react'

import styles from './styled-group-header.module.css'

export const GROUP_HEADER_HEIGHT = 44

export const StyledGroupHeader = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'> & {topOffset?: number}>(
  ({topOffset, style, children, className, ...props}, ref) => {
    return (
      <div
        ref={ref}
        style={{top: topOffset ?? 0, height: `${GROUP_HEADER_HEIGHT}px`, ...style}}
        className={clsx(styles.styledGroupHeaderWrapper, className)}
        {...props}
      >
        {children}
      </div>
    )
  },
)

StyledGroupHeader.displayName = 'StyledGroupHeader'
